module.exports = __webpack_public_path__ + "img/order-step4-b.46d1e221.png";